import type { SelectionContext } from '@/contentComponents/modal/AssignGroupStudentModal/AssignGroupStudentModal'

import { SCHEDULE_STRINGS } from '../_constants/scheduleStrings'
import type { Reservation } from '../_service/AssignSchedule.service'

type FormView = {
  enabled: boolean
  isTimeChanged: boolean
  getLimitError: (studentCount: number) => string | null
}

/** 한도 판정 인원. 예약이 있으면 이미 예약된 학생까지 합친 총원이 BE 의 batch 단위 한도 대상이다 */
export const countStudentsForLimit = (
  reservation: Reservation,
  ctx: Pick<SelectionContext, 'movedToRightItems'>,
) =>
  ctx.movedToRightItems.length + (reservation.kind === 'existing' ? reservation.studentIds.size : 0)

export type SubmitState = { label: string; disabled: boolean }

/**
 * 확정 버튼의 라벨과 비활성 조건. 설계 스펙 §6 상황 표와 1:1 로 대응한다
 *
 * | 예약 | 변경                | 라벨          | 비활성          |
 * | 없음 | 토글 OFF            | 바로 출제하기 | 선택 변화 없음  |
 * | 없음 | 토글 ON             | 예약 출제하기 | 선택 변화 없음  |
 * | 없음 | 토글 ON · 한도 초과 | 바로 출제하기 | 항상            |
 * | 있음 | 없음                | 출제 예약됨   | 항상            |
 * | 있음 | 학생 추가·시각 변경 | 예약 변경하기 | 한도 초과       |
 */
export const resolveSubmitState = (
  form: FormView,
  reservation: Reservation,
  ctx: Pick<SelectionContext, 'isChanged' | 'movedToRightItems'>,
): SubmitState => {
  const newStudentCount = ctx.movedToRightItems.length
  const overLimit = !!form.getLimitError(countStudentsForLimit(reservation, ctx))

  if (reservation.kind === 'existing') {
    const hasChanges = newStudentCount > 0 || form.isTimeChanged
    return hasChanges
      ? { label: SCHEDULE_STRINGS.submitChange, disabled: overLimit }
      : { label: SCHEDULE_STRINGS.submitReserved(), disabled: true }
  }

  const scheduling = form.enabled && !overLimit
  return scheduling
    ? { label: SCHEDULE_STRINGS.submitSchedule(), disabled: !ctx.isChanged }
    : {
        label: SCHEDULE_STRINGS.submitNow(),
        disabled: !ctx.isChanged || (form.enabled && overLimit),
      }
}
